export default function ActivationSiteSynchroConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('activation.site.synchro');
}

ActivationSiteSynchroConfiguration.$inject = ['$translatePartialLoaderProvider'];
